import { CustomizeStandardPage } from "./CustomizeStandardPage";

export default CustomizeStandardPage;